export const isImpersonated = () => {
  return !!localStorage.getItem('admin');
};

export const getAdminObject = () => {
  return JSON.parse(localStorage.getItem('admin'));
};

export const removeAdminFromLocalStorage = () => {
  return localStorage.removeItem('admin');
};
